/* eslint-disable */
const hash = {
  "en-US": "53a0b4c9",
  "de-DE": "57979868",
  "es-ES": "2dc9a6c6",
  "fr-FR": "da4e61ff",
  "id-ID": "610de423",
  "it-IT": "1b98dc82",
  "jp-JP": "871bf4e0",
  "ko-KO": "7927d278",
  "nl-NL": "ac16847f",
  "pl-PL": "4a7f953b",
  "pt-PT": "11561525",
  "ru-RU": "6f0618d7",
  "tr-TR": "be09495f",
  "vi-VN": "8c407d57",
  "zh-CN": "85075a76",
  "zh-TW": "abbb05cd",
  "sv-SE": "e18104e9",
  "control": "1e9fcbbd",
  "plan-details": "4158ef36",
  "gov-EN": "908e3c2a",
  "en-GB": "ea2eb8cd"
}
export default hash
